import { createAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { ViewItem } from '../model/view-item.model';

export interface UpdateItems {
    items: ViewItem[];
    patch: { read: boolean; delete: boolean };
}

export const updateItems = createAction<ActionType, UpdateItems>(
    ActionType.NOTI__EC__UPDATE_ITEMS,
);

export interface UpdateItemsResult extends UpdateItems {}

export const updateItemsResult = createAction<ActionType, UpdateItemsResult>(
    ActionType.NOTI__EC__UPDATE_ITEMS_RESULT,
);
